import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Box,
    Button,
    FlexBox,
    FluidImage,
    H1,
    P,
} from '@vp/swan';
import { __, __image } from '@99designs/i18n';
import { usePricingProviderContext } from '@99designs/pricing';
import { CloudinaryImage } from '../CloudinaryImage';
import { HeaderPrice } from '../HeaderPrice';

interface HeaderProps {
    browseDesignServicesCtaOnClick: () => void;
    howItWorksCtaOnClick: () => void;
}

export function Header({ browseDesignServicesCtaOnClick, howItWorksCtaOnClick }: HeaderProps) {
    const { lowestPrice, loading: priceLoading } = usePricingProviderContext();

    return (
        <Banner backgroundColor="accent" data-testid="hero">
            <BannerTextContainer>
                <BannerText data-testid="hub-hero-content">
                    <BannerEyebrow data-testid="hub-hero-eyebrow">
                        {__('Design Services')}
                    </BannerEyebrow>
                    <BannerTitle as={H1} fontSkin="title-headline" data-testid="hub-hero-title">
                        {__('You take care of your business, we’ll take care of the design')}
                    </BannerTitle>
                    <BannerDescription data-testid="hub-hero-description">
                        <P>
                            {__(
                                'Work with professional, talented designers to bring your brand to life – from handcrafted logos to custom marketing materials and beyond.'
                            )}
                        </P>
                    </BannerDescription>
                    <Box fontSkin="title-item" data-testid="hub-hero-price">
                        <HeaderPrice price={lowestPrice} loading={priceLoading} />
                    </Box>
                    <BannerLinks data-testid="hub-hero-actions">
                        <Button
                            skin="primary"
                            onClick={browseDesignServicesCtaOnClick}
                            data-testid="hub-hero-browse-services-cta"
                        >
                            {__('Browse design services')}
                        </Button>
                        <Button
                            skin="secondary"
                            onClick={howItWorksCtaOnClick}
                            data-testid="hub-hero-how-it-works-cta"
                        >
                            {__('How it works')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <FlexBox
                style={{ flexBasis: '50%' }}
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
                data-testid="hub-hero-image"
            >
                <CloudinaryImage
                    render={(props) => (
                        <FluidImage
                            src={props.src}
                            srcSet={props.srcSet}
                            alt=""
                            role="presentation"
                        />
                    )}
                    imagePath={__image('expert_services/HubPage/hero-image')}
                    width={686}
                />
            </FlexBox>
        </Banner>
    );
}
